import { Android16 } from 'ui/icons/devices/Android16';
import { Apple16 } from 'ui/icons/devices/Apple16';
import { Google16 } from 'ui/icons/devices/Google16';
import { Microsoft16 } from 'ui/icons/devices/Microsoft16';
import { Mobile16 } from 'ui/icons/devices/Mobile16';
import { SvgIconProps } from 'ui/icons/SvgIcon';
import { Web16 } from 'ui/icons/devices/Web16';
import { UserClientType } from '../domain';

export enum GridArea {
  recentEventsTitle = 'recentEventsTitle',
  avatar = 'avatar',
  contactDetails = 'contactDetails',
  recentEventsList = 'recentEventsList',
}

export const CLIENT_TYPE_ICONS: Record<
  UserClientType,
  React.ComponentType<React.PropsWithChildren<SvgIconProps>>
> = {
  [UserClientType.android]: Android16,
  [UserClientType.apple]: Apple16,
  [UserClientType.google]: Google16,
  [UserClientType.microsoft]: Microsoft16,
  [UserClientType.mobile]: Mobile16,
  [UserClientType.desktop]: Web16,
};

export const RECENT_EVENTS_POLLING_INTERVAL_MS = 60 * 1000; // Poll ever 60 seconds
export const RECENT_EVENTS_ANIMATION_STAGGER_DELAY_MS = 250;
export const RECENT_EVENTS_ROW_COUNT = 3;
export const AUDIENCE_USERPROFILE_SLIDEOVER_KEY = 'audience-userprofile-slideover';
